export default __webpack_public_path__ + "static/media/cut.43b4feb5.svg";